import React, { useEffect, useRef, useState } from "react";
import IconLoader from "../../../component/IconLoader";
import CustomeModal from "../../../component/modal-popup/customeModal";
import swal from "@sweetalert/with-react";
import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import { sanitizeInput } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { getMultipleAssignmentData } from "../../../redux/actions/purchaseOrder";
import moment from "moment";
import SimpleBarReact from "simplebar-react";
import {
  getDeptUserAndCollaborator,
  getToDoList,
  getWorkflowList,
} from "../Helpers";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DragAndDropTodoItem from "../Component/DragAndDropTodoItem";
import { getWorkingHours } from "../../../redux/actions/company";
import {
  Collaborator,
  Customer,
} from "../../../constant/AuthenticationConstant";
import { getAssignmentDataByConfigurationId } from "../../../redux/actions/assignmentAction";
import SideModal from "../../../component/SideModal";
import PerformanceModal from "../Component/PerformanceModal";

const WorkflowTab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  //   Redux State
  const { company } = useSelector((state) => state.auth);
  const { configurationData } = useSelector(
    (state) => state.configurationReducer
  );
  const { allActivityList } = useSelector((state) => state.assignmentReducer);
  const { deptWithUserAndCollaborators } = useSelector(
    (state) => state.department
  );

  // Raw List For Selection Options
  const [deptList, setDeptList] = useState([]);
  const [todoList, setTodoList] = useState([]);
  const [workflowList, setWorkflowList] = useState([]);
  const [workingHours, setWorkingHours] = useState({});
  const [activeTodo, setActiveTodo] = useState(null);
  const [activeModal, setActiveModal] = useState(false);

  useEffect(() => {
    getWorkflowList(dispatch, company.id);
    getToDoList(dispatch, company.id);
    getDeptUserAndCollaborator(dispatch, company.id);
    const request = {
      onSuccess: (results) => {
        if (results.status) {
          setWorkingHours(results.data);
        }
      },
      onError: () => {},
    };
    dispatch(getWorkingHours(request));
  }, []);

  useEffect(() => {
    if (configurationData?.data?.length > 0) {
      setWorkflowList(
        configurationData.data.map((workflowItem) => ({
          label: workflowItem.configuration_name,
          value: workflowItem.configuration_id,
        }))
      );
    }
    return () => {
      setWorkflowList([]);
    };
  }, [configurationData]);

  useEffect(() => {
    if (allActivityList?.length > 0) {
      setTodoList(
        allActivityList
          .filter((item) => item.deletedAt === null)
          .map((item) => ({
            label: item.name,
            value: item.id,
          }))
      );
    }
  }, [allActivityList]);

  useEffect(() => {
    if (deptWithUserAndCollaborators?.departments?.length > 0) {
      setDeptList(
        deptWithUserAndCollaborators?.departments?.map((item) => ({
          label: item.label,
          value: item.value,
        }))
      );
    }
  }, [deptWithUserAndCollaborators]);

  useEffect(() => {
    setLoader(true);
    const request = {
      inventory_order_id: "",
      inventory_order_type: assignmentFormik.values.inventory_order_type,
      onSuccess: (result) => {
        const assignmentData = result.data.map((resultItem) => {
          const obj = {
            activity_assignment_id: resultItem.activity_assignment_id,
            alias: resultItem.alias,
            workflow_id: resultItem.workflow_id,
            assignments: resultItem.activity_assignment_mappings.map(
              (assignmentMappingItem) => {
                const assignmentObj = {
                  activity_assignment_mapping_id:
                    assignmentMappingItem.activity_assignment_mapping_id,
                  activity_id: assignmentMappingItem.activity_id,
                  collaborator_id: assignmentMappingItem.collaborator_id,
                  department_id: assignmentMappingItem.department_id,
                  duration: assignmentMappingItem.duration,
                  estimated_time: assignmentMappingItem.estimated_time,
                  is_mandatory: assignmentMappingItem.is_mandatory,
                  link_activity: assignmentMappingItem.link_activity,
                  loop_activity: assignmentMappingItem.loop_activity,
                  reminder_time: assignmentMappingItem.reminder_time,
                  sequence: assignmentMappingItem.sequence,
                  status: assignmentMappingItem.status,
                  user_id: assignmentMappingItem.user_id,
                  dept_timzone: assignmentMappingItem.dept_timzone,
                  user_timzone: assignmentMappingItem.user_timzone,
                  departmentSelect: "",
                  userSelect: "",
                  reminderTimeDropdownVal: "",
                };

                if (assignmentMappingItem.department) {
                  assignmentObj.departmentSelect = {
                    label: assignmentMappingItem.department.name,
                    value: assignmentMappingItem.department.id,
                  };
                } else if (assignmentMappingItem.collaborator) {
                  assignmentObj.departmentSelect = {
                    label:
                      assignmentMappingItem.collaborator.type === "collaborator"
                        ? "Collaborator"
                        : "Customer",
                    value: assignmentMappingItem.collaborator.type,
                  };
                }

                if (assignmentMappingItem.user) {
                  assignmentObj.userSelect = {
                    label: assignmentMappingItem.user.name,
                    value: assignmentMappingItem.user.id,
                  };
                } else if (assignmentMappingItem.collaborator) {
                  assignmentObj.userSelect = {
                    label: assignmentMappingItem.collaborator.name,
                    value: assignmentMappingItem.collaborator.collaborator_id,
                  };
                }

                // if(assignmentMappingItem.reminder_time && assignmentMappingItem.estimated_time) {
                //   assignmentObj.reminderTimeDropdownVal = reminderTimeDropdownOptions.find((reminderTimeOption) => reminderTimeOption.value ===  moment(assignmentMappingItem.estimated_time).diff(
                //     moment(assignmentMappingItem.reminder_time),
                //     "hours"
                //   ))
                // }

                return assignmentObj;
              }
            ),
          };
          return obj;
        });
        assignmentFormik.setFieldValue("workflows", assignmentData);
        setLoader(true);
      },
      onError: (error) => {
        setLoader(false);
        // swal({
        //   content: (
        //     <CustomeModal
        //       type="error"
        //       title="Error!"
        //       content={error?.message}
        //     />
        //   ),
        //   buttons: false,
        //   closeOnClickOutside: false,
        //   closeOnEsc: false,
        // });
      },
    };
    dispatch(getMultipleAssignmentData(request));
  }, []);

  useEffect(() => {
    if (activeTodo !== null) {
      setActiveModal(true);
    }
  }, [activeTodo]);

  useEffect(() => {
    if (!activeModal) {
      setActiveTodo(null);
    }
  }, [activeModal]);

  const assignmentFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      inventory_order_id: "",
      inventory_order_type: "sales_order",
      booking_template_id: "",
      workflows: [
        {
          workflow_id: null,
          alias: "",
          assignments: [],
        },
      ],
    },
    onSubmit: (value) => {
      const payload = {
        inventory_order_id: value.inventory_order_id,
        inventory_order_type: value.inventory_order_type,
        booking_template_id: value.booking_template_id,
        workflows: value.workflows.map((workflowData) => {
          const obj = {
            ...workflowData,
            assignments: workflowData.assignments.map(
              (assignmentItem, index) => {
                const assignmentObj = {
                  ...assignmentItem,
                  sequence: index + 1,
                  reminder_time: assignmentItem.reminder_time
                    ? new Date(assignmentItem.reminder_time).toISOString()
                    : null,
                };

                delete assignmentObj.userSelect;
                delete assignmentObj.departmentSelect;
                delete assignmentObj.reminderTimeDropdownVal;

                return assignmentObj;
              }
            ),
          };
          return obj;
        }),
      };
      // submitAssignment(payload);
    },
  });

  // Function to GET Assignment data by workflow_id
  const getToDoAssignmentByWorkflowId = (workflow_id, index) => {
    console.log("This is working.");
    const request = {
      configurationId: workflow_id,
      onSuccess: (data) => {
        assignmentFormik.setFieldValue(
          `workflows[${index}].assignments`,
          data.map((assignmentItem) => {
            const obj = {
              activity_id: assignmentItem.activity_id,
              department_id: assignmentItem.activity.department,
              user_id: assignmentItem.activity.user,
              sequence: assignmentItem.sequence,
              is_mandatory: assignmentItem.is_mandatory,
              link_activity: assignmentItem.link_activity,
              loop_activity: assignmentItem.loop_activity,
              duration: assignmentItem.duration,
              collaborator_id: assignmentItem.activity.collaborator_id,
              dept_timzone: assignmentItem.activity.dept_timzone,
              user_timzone: assignmentItem.activity.user_timzone,
              estimated_time: "",
              reminder_time: "",
              departmentSelect: "",
              userSelect: "",
              reminderTimeDropdownVal: "",
              status: "pending",
            };

            if (assignmentItem.activity.department) {
              obj.departmentSelect = {
                label: assignmentItem.activity.assign_department.name,
                value: assignmentItem.activity.assign_department.id,
              };
              if (obj.user_id) {
                obj.userSelect =
                  deptWithUserAndCollaborators?.departments
                    .find(
                      (item) =>
                        item.value === assignmentItem.activity.department
                    )
                    ?.user_departments.find(
                      (item) => item.value === obj?.user_id
                    ) || "";
              }
            } else if (
              obj.collaborator_id &&
              !assignmentItem.activity.is_assign_to_customer
            ) {
              obj.departmentSelect = {
                label: "Collaborator",
                value: Collaborator,
              };
            } else if (
              !obj.collaborator_id &&
              assignmentItem.activity.is_assign_to_customer
            ) {
              obj.departmentSelect = {
                label: "Customer",
                value: Customer,
              };
            }

            if (obj.collaborator_id) {
              obj.userSelect =
                deptWithUserAndCollaborators?.collaborators.find(
                  (item) => item.value === obj.collaborator_id
                ) || "";
              // obj.userSelect = customerAndCollaboratorOptions.find(
              //   (item) => item.value === obj.collaborator_id
              // );
            }
            //   else if (obj.user_id) {
            //     obj.userSelect = usersOptions.find(
            //       (item) => item.value === obj.user_id
            //     );
            //   }

            return obj;
          })
        );
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAssignmentDataByConfigurationId(request));
  };

  const getTranslatePercentage = () => {
    return `-translate-x-[${activeTodo?.index * 25}%]`
  }

  const container = useRef(null);

  return (
    <>
      {loader ? (
        <IconLoader />
      ) : (
        <div
          className="h-screen w-screen overflow-x-auto overflow-y-hidden"
          style={{ height: "calc(100vh - 148px)"}}
        >
          <div
            ref={container}
            className={`py-6 w-full h-full overflow-x-auto overflow-y-hidden scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100 transition-transform duration-1000 ease-in-out`}
            style={{
              transform: activeModal ? `translateX(-${((activeTodo?.index ) * 440) + (activeTodo?.index * 16) || 0}px)` : "translateX(0)",
              width: activeModal ? `calc(100vw + ${parseInt(activeTodo?.index * 440) || 0}px)` : assignmentFormik.values.workflows?.length % 3 > 0 ? `calc(100vw + ${parseInt( assignmentFormik.values.workflows?.length % 3) * 440 || 0}px)` : "100%" 
            }}
          >
            <FormikProvider value={assignmentFormik}>
              <Form autoComplete="off" noValidate>
                <FieldArray
                  name="workflows"
                  render={(arrayHelpers) => (
                    <div className="flex space-x-4 items-start">
                      {assignmentFormik.values.workflows.map((item, index) => {
                        return (
                          <div className="space-y-6">
                            {/* Workflow Form */}
                            <div className="rounded-md w-[440px] py-6 px-4 bg-[--bg-color-50] space-y-4">
                              <div className="flex items-center space-x-4">
                                <input
                                  type="text"
                                  className="form-input !border-t-0 !border-r-0 !border-l-0 !border-b-2 !border-[#D9D9D9] !bg-[--bg-color-50] w-full !rounded-none !shadow-none !pt-0 !text-base font-semibold text-[#1E293B] !pl-0"
                                  placeholder="Workflow Name"
                                  onChange={(e) => {
                                    const value = sanitizeInput(e.target.value);
                                    assignmentFormik.setFieldValue(
                                      `workflows[${index}].alias`,
                                      value
                                    );
                                  }}
                                  value={
                                    assignmentFormik.values.workflows[index]
                                      .alias
                                  }
                                />
                              </div>
                              <div>
                                <label
                                  className={`block text-sm font-medium mb-1 leading-3 tracking-tight`}
                                >
                                  Workflow
                                </label>
                                <Select
                                  className="basic-single text-sm unresetText"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      backgroundColor: "white",
                                      borderColor: "lightgray",
                                    }),
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    placeholder: (provided, state) => ({
                                      ...provided,
                                      color: "#9297A2",
                                      fontSize: "14px",
                                    }),
                                  }}
                                  classNames={{
                                    control: (style) => {
                                      return `!border !shadow-sm ${
                                        style.isFocused
                                          ? "!border-[--bg-color-300]/50"
                                          : "!border-slate-200 hover:!border-gray-300"
                                      }`;
                                    },
                                    container: (style) => {
                                      return "!h-[37.5px] !font-inter !text-sm";
                                    },
                                    menuList: (style) => {
                                      return `!max-h-[200px]`;
                                    },
                                  }}
                                  onChange={(workflowData) => {
                                    assignmentFormik.setFieldValue(
                                      `workflows[${index}].workflow_id`,
                                      workflowData.value
                                    );
                                    if (workflowData) {
                                      getToDoAssignmentByWorkflowId(
                                        workflowData.value,
                                        index
                                      );
                                    }
                                  }}
                                  value={
                                    assignmentFormik.values.workflows[index]
                                      .workflow_id
                                      ? workflowList.find(
                                          (workflowEle) =>
                                            workflowEle.value ===
                                            assignmentFormik.values.workflows[
                                              index
                                            ].workflow_id
                                        )
                                      : ""
                                  }
                                  options={workflowList}
                                  placeholder="Select Workflow"
                                />
                              </div>
                            </div>
                            {/* To Dos related to Workflow */}
                            <DndProvider backend={HTML5Backend}>
                              <div className="h-screen">
                                <SimpleBarReact
                                  style={{ maxHeight: "calc(100vh - 385px)" }}
                                >
                                  <div className="w-[440px] space-y-4">
                                    <FieldArray
                                      name={`workflows[${index}].assignments`}
                                      render={(arrayHelpersToDo) => {
                                        return (
                                          <>
                                            {item.assignments.map(
                                              (element, i) => {
                                                return (
                                                  <DragAndDropTodoItem
                                                    assignmentFormik={
                                                      assignmentFormik
                                                    }
                                                    arrayHelpersToDo={
                                                      arrayHelpersToDo
                                                    }
                                                    index={index}
                                                    i={i}
                                                    element={element}
                                                    todoList={todoList}
                                                    deptList={deptList}
                                                    workingHours={workingHours}
                                                    activeTodo={activeTodo}
                                                    setActiveTodo={
                                                      setActiveTodo
                                                    }
                                                  />
                                                );
                                              }
                                            )}

                                            {item?.assignments?.length ===
                                              0 && (
                                              <div className="w-full">
                                                <button
                                                  className="w-full btn bg-white border-slate-200 hover:border-slate-300 text-[--bg-color-500] cursor-pointer font-semibold"
                                                  onClick={() => {
                                                    arrayHelpersToDo.push({
                                                      // activity_assignment_mapping_id:
                                                      //   "", // used while updating
                                                      activity_id: null,
                                                      department_id: null,
                                                      user_id: null,
                                                      sequence: 1,
                                                      is_mandatory: false,
                                                      link_activity: null,
                                                      loop_activity: null,
                                                      duration: 0,
                                                      collaborator_id: null,
                                                      estimated_time: null,
                                                      reminder_time: null,
                                                      departmentSelect: "",
                                                      userSelect: "",
                                                      reminderTimeDropdownVal:
                                                        "",
                                                      status: "pending",
                                                    });
                                                  }}
                                                >
                                                  + Add To Do
                                                </button>
                                              </div>
                                            )}

                                            <div className="w-full">
                                              <button
                                                type="button"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  if (
                                                    item?.activity_assignment_id
                                                  ) {
                                                    swal({
                                                      content: (
                                                        <CustomeModal
                                                          type="delete"
                                                          title="Are you sure?"
                                                          content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                                                          onDelete={() => {
                                                            // handleDeleteWorkflow(
                                                            //   item
                                                            // );
                                                            arrayHelpers.remove(
                                                              index
                                                            );
                                                          }}
                                                        />
                                                      ),
                                                      buttons: false,
                                                      closeOnClickOutside: false,
                                                      closeOnEsc: false,
                                                    });
                                                  } else {
                                                    arrayHelpers.remove(index);
                                                  }
                                                }}
                                                className="w-full btn !bg-[#EB5757] text-[13px] font-semibold text-white"
                                              >
                                                Delete Workflow
                                              </button>
                                            </div>
                                          </>
                                        );
                                      }}
                                    />
                                  </div>
                                </SimpleBarReact>
                              </div>
                            </DndProvider>
                          </div>
                        );
                      })}

                      <h4
                        className="text-sm font-semibold text-[--bg-color-500] tracking-tight leading-5 cursor-pointer min-w-[108px]"
                        onClick={() =>
                          arrayHelpers.push({
                            alias: "",
                            workflow_id: "",
                            assignments: [],
                          })
                        }
                      >
                        + Add Workflow
                      </h4>
                    </div>
                  )}
                />
              </Form>
            </FormikProvider>
          </div>

          <SideModal
            isOpen={activeModal}
            setIsOpen={setActiveModal}
            title={""}
            subtitle={"Todo Name"}
            widthClass={"w-[50%]"}
          >
            <PerformanceModal />
          </SideModal>
        </div>
      )}
    </>
  );
};

export default WorkflowTab;
